module.exports = __webpack_public_path__ + "Server-Unhealthy.TentaclePassive.f473525c9942c566bf2c9406b5b0a0a3.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unhealthy.TentaclePassive.png
// module id = 82304741352737
// module chunks = 1